// Encodes array of filters to string separated by (encoded) commas
// ["HUL¤102"] -> "HUL%C2%A4102"
export function encodeParam(values) {
  if (values == null) return null;

  return encodeURIComponent(values.id.map(val => `${val}`).join(","));
}
